const SET_PARTNER_LINKS = 'AFTERMARKET_PARTNER_SET_PARTNER_LINKS';
const SET_IS_INTEGRATION_ADMIN_ACCOUNT = 'SET_IS_INTEGRATION_ADMIN_ACCOUNT';
const CLEAR = 'MENU_CONSTRUCTOR_CLEAR';

export { SET_PARTNER_LINKS, SET_IS_INTEGRATION_ADMIN_ACCOUNT, CLEAR };
